import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

const FARO_COLLECTOR_URL =
  'https://faro-collector-prod-sa-east-1.grafana.net/collect/f45cf462932a6d711a9f0ce72c005f88';

let faroInstance: ReturnType<typeof initializeFaro> | null = null;

export function initTelemetry(serviceName: string, serviceVersion: string, appEnvironment: string): void {
  // Skip initialization during Karma unit tests to avoid fetch errors
  if (faroInstance || (typeof window !== 'undefined' && (window as any).__karma__)) {
    return;
  }

  faroInstance = initializeFaro({
    url: FARO_COLLECTOR_URL,
    app: {
      name: serviceName,
      version: serviceVersion,
      environment: appEnvironment,
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation({
        instrumentationOptions: {
          propagateTraceHeaderCorsUrls: [/.*/],
        },
      }),
    ],
  });
}

export function trackLoginSuccess(durationMs: number, hostname: string): void {
  faroInstance?.api.pushEvent('auth_login_success', {
    duration_ms: String(durationMs),
    hostname,
  });
}

export function trackLoginFailure(durationMs: number, hostname: string, errorType: string): void {
  faroInstance?.api.pushEvent('auth_login_failure', {
    duration_ms: String(durationMs),
    hostname,
    error_type: errorType,
  });
}
